import * as z from "zod";
import { SUPPORTED_CURRENCIES } from "@/api/currency";

// Get all supported currency values for validation
const validCurrencies = SUPPORTED_CURRENCIES.map(c => c.value);

// Define form schema with validation rules
export const formSchema = z.object({
  date: z.date({
    required_error: "Tarih seçimi zorunludur.",
  }),
  projectId: z.string({
    required_error: "Proje seçimi zorunludur.",
  }),
  description: z.string().min(3, "Açıklama en az 3 karakter olmalıdır."),
  amount: z.string().min(1, "Tutar girilmelidir."),
  hasInvoice: z.boolean().default(false),
  isMiscellaneous: z.boolean().default(false),
  personId: z.string().optional(),
  photos: z.array(z.string()).optional(),
  original_currency: z.string().refine(
    (val) => validCurrencies.includes(val),
    {
      message: "Geçersiz para birimi",
      path: ["original_currency"],
    }
  ).default("TRY"),
  // Payment method model
  paymentMethod: z.enum(["cash_card", "check", "advance", "open_account"]).default("cash_card"),
  advanceSubMethod: z.enum(["cash_card", "check"]).optional(),
  dueDate: z.date().optional(),
}).superRefine((data, ctx) => {
  // Advance and Açık Hesap must be tied to a person
  if ((data.paymentMethod === "advance" || data.paymentMethod === "open_account") && !data.personId) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Bu ödeme tipi için bir kişi seçilmelidir.",
      path: ["personId"],
    });
  }
  // Advance requires a sub-method (cash/card or check)
  if (data.paymentMethod === "advance" && !data.advanceSubMethod) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Ödeme şekli seçilmelidir.",
      path: ["advanceSubMethod"],
    });
  }
  // Check (or advance-by-check) requires a due date
  const needsDueDate =
    data.paymentMethod === "check" ||
    (data.paymentMethod === "advance" && data.advanceSubMethod === "check");
  if (needsDueDate && !data.dueDate) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Vade tarihi seçilmelidir.",
      path: ["dueDate"],
    });
  }
});

// Mock data providers
export const getProjects = () => [
  { id: "1", name: "Marina Towers" },
  { id: "2", name: "Green Valley" },
];

export const getPeople = () => [
  { id: "1", name: "Ahmet Yılmaz", category: "laborer" },
  { id: "2", name: "Mehmet Demir", category: "supplier" },
  { id: "3", name: "Can İnşaat Ltd.", category: "subcontractor" },
];
